<template lang="pug">
div
  .ActionRecibirEquipo
    //- BOTON Recibir Equipo
    button.change-button(
      :disabled="disabled || setDisabled || loading",
      @click="RecibirEquipo"
    ) 
      span Recibir Equipo
      b-spinner(v-if="loading" class="ml-2" variant="white" small)
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionRecibirEquipo',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      setDisabled: false,
    };
  },
  methods: {
    ...mapActions('OTStore', ['recibirEquipo']),
    async RecibirEquipo() {
      try {
        await this.executeWithLoading(async () => {
          const resp = await this.recibirEquipo(this.ot.ot);
          console.log(resp);
          if (resp && resp.status === 200) {
            this.setDisabled = true;
            this.$bvToast.toast('Se ha recibido el equipo correctamente', {
              variant: 'success',
            });
          } else {
            this.$bvToast.toast('Error al recibir el equipo', {
              variant: 'danger',
            });
          }
        })
      } catch (error) {
        console.error('Error al recibir equipo:', error)
        this.$bvToast.toast('Error al recibir el equipo', {
          variant: 'danger',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
